import React, { useState } from 'react';
import Icon from '../../../Images/ps_logo.png';
import LogoIcon from '../../../Images/login_img.png';
import Button from '../../shared-components/Button/custom-button';
import './Login.css'
const Login = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setEmailError('');
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setPasswordError('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!email) {
            setEmailError('Please enter your email');
        } else if (!validateEmail(email)) {
            setEmailError('Please enter a valid email');
        }

        if (!password) {
            setPasswordError('Please enter your password');
        }

        // Perform additional validation or submit the form
        if (email && password && validateEmail(email)) {
            onLogin(email, password); // Call the onLogin callback provided by the parent component
        }
    };

    const validateEmail = (email) => {
        // Simple email validation regex pattern
        const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return pattern.test(email);
    };


    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-12 col-lg-9">
              <div className="row border rounded shadow overflow-hidden" style={{ backgroundColor: 'white' }}>
               {/* Left side - Image (Moves Below on Small Screens) */}
              <div className="col-12 col-lg-6 order-1 d-flex align-items-center justify-content-center login-image-container">
                  <img 
                    src={LogoIcon}
                    alt="Logo"
                    className="img-fluid"
                    style={{ maxWidth: '100%', objectFit: 'contain' }}
                  />
                </div>
                {/* Right side - Form (Always First) */}
                <div className="col-12 col-lg-6 order-lg-1 p-4 mt-lg-2">
                  <div className='mt-lg-5'>
                    <img src={Icon} alt="Logo" style={{ maxHeight: '50px', maxWidth: '70%' }} />
                    <h4 className="mt-4">Hello! Let's get started</h4>
                    <h6 className="text-muted">Sign in to continue.</h6>
                  </div>
    
                  <form onSubmit={handleSubmit} className="form-custom mt-4">
                    {/* Email field */}
                    <div className="form-group mb-3">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Username"
                        value={email}
                        onChange={handleEmailChange}
                        required
                      />
                    </div>
    
                    {/* Password field */}
                    <div className="form-group mb-3">
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        onChange={handlePasswordChange}
                        required
                      />
                    </div>
    
                    {/* Sign in button */}
                    <button type="submit" className="btn btn-primary w-100">
                      SIGN IN
                    </button>
    
                    {/* Keep me signed in */}
                    <div className="form-check mt-3">
                      <input type="checkbox" className="form-check-input" id="keepSignedIn" />
                      <label className="form-check-label" htmlFor="keepSignedIn">
                        Keep me signed in
                      </label>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    
    
};

export default Login;
